import { render, staticRenderFns } from "./TransferTeamsFromGrid.vue?vue&type=template&id=df1fb476&scoped=true"
import script from "./TransferTeamsFromGrid.vue?vue&type=script&lang=js"
export * from "./TransferTeamsFromGrid.vue?vue&type=script&lang=js"
import style0 from "./TransferTeamsFromGrid.vue?vue&type=style&index=0&id=df1fb476&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1fb476",
  null
  
)

export default component.exports